import React from 'react';
export const Biclycle = () => (
  <svg width="201px" height="157px" viewBox="0 0 201 157" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1300.000000, -507.000000)">
        <g transform="translate(1300.000000, 507.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M158.4048,154.2074 L175.1508,154.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M23.563,154.2074 L15.526,154.2074"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.1274,154.7485 C60.1274,155.6835 54.3964,156.4415 47.3254,156.4415 C40.2554,156.4415 34.5234,155.6835 34.5234,154.7485 C34.5234,153.8125 40.2554,153.0545 47.3254,153.0545 C54.3964,153.0545 60.1274,153.8125 60.1274,154.7485"
            fill="#D0D7DA"
          />
          <path
            d="M123.0073,154.7485 C123.0073,155.6835 117.2763,156.4415 110.2053,156.4415 C103.1353,156.4415 97.4033,155.6835 97.4033,154.7485 C97.4033,153.8125 103.1353,153.0545 110.2053,153.0545 C117.2763,153.0545 123.0073,153.8125 123.0073,154.7485"
            fill="#D0D7DA"
          />
          <path
            d="M35.8682,147.5326 C38.8672,150.2866 42.8642,151.9696 47.2462,151.9696 C56.5322,151.9696 64.0862,144.4146 64.0862,135.1286 C64.0862,125.8436 56.5322,118.2886 47.2462,118.2886 C37.9602,118.2886 30.4072,125.8436 30.4072,135.1286 C30.4072,135.6596 30.4312,136.1836 30.4792,136.7026 L35.8682,147.5326 Z M47.2462,153.8676 C36.9132,153.8676 28.5082,145.4606 28.5082,135.1286 C28.5082,124.7966 36.9132,116.3896 47.2462,116.3896 C57.5782,116.3896 65.9842,124.7966 65.9842,135.1286 C65.9842,145.4606 57.5782,153.8676 47.2462,153.8676 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M99.7202,147.5258 C101.3222,148.9968 103.2082,150.1618 105.2852,150.9268 L116.7322,150.9908 C123.2522,148.6668 127.9312,142.4318 127.9312,135.1248 C127.9312,125.8398 120.3792,118.2888 111.0952,118.2888 C101.8122,118.2888 94.2602,125.8398 94.2602,135.1248 C94.2602,135.6548 94.2842,136.1798 94.3332,136.6978 L99.7202,147.5258 Z M111.0952,153.5608 C100.7652,153.5608 92.3622,145.4548 92.3622,135.1248 C92.3622,124.7948 100.7652,116.3898 111.0952,116.3898 C121.4262,116.3898 129.8292,124.7948 129.8292,135.1248 C129.8292,145.4548 121.4262,153.5608 111.0952,153.5608 Z"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M65.9849,135.1283 C65.9849,145.4783 57.5949,153.8673 47.2459,153.8673 C36.8969,153.8673 28.5069,145.4783 28.5069,135.1283 C28.5069,124.7793 36.8969,116.3903 47.2459,116.3903 C57.5949,116.3903 65.9849,124.7793 65.9849,135.1283 Z"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M67.4282,135.1283 C67.4282,146.2743 58.3922,155.3113 47.2462,155.3113 C36.1002,155.3113 27.0642,146.2743 27.0642,135.1283 C27.0642,123.9823 36.1002,114.9463 47.2462,114.9463 C58.3922,114.9463 67.4282,123.9823 67.4282,135.1283 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M129.834,135.1283 C129.834,143.4203 124.448,150.4543 116.984,152.9233 L105.62,153.0543 C97.942,150.7123 92.357,143.5723 92.357,135.1283 C92.357,124.7793 100.747,116.3903 111.096,116.3903 C121.445,116.3903 129.834,124.7793 129.834,135.1283 Z"
            stroke="#FFFFFF"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M122.2134,151.975 C121.0894,152.718 119.8884,153.351 118.6224,153.861"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M99.9692,151.9692 C94.5122,148.3572 90.9132,142.1632 90.9132,135.1282 C90.9132,123.9832 99.9492,114.9472 111.0952,114.9472 C122.2412,114.9472 131.2772,123.9832 131.2772,135.1282 C131.2772,142.1662 127.6752,148.3642 122.2132,151.9752"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.5342,153.8461 C102.2782,153.3381 101.0852,152.7081 99.9692,151.9691"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.3975,108.2133 L98.5555,100.3253"
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M111.0957,135.1283 L101.3977,108.2133"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.6729,109.1108 L62.7149,103.6878"
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.0635,135.1283 L64.6725,109.1103"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M102.4927,111.394 C102.4927,111.394 75.6847,108.365 63.5997,116.328 C51.5147,124.29 47.2457,135.128 47.2457,135.128 L74.1807,135.128 C77.9927,133.726 80.5657,133.215 85.1607,121.781 C89.7557,110.345 102.4927,111.394 102.4927,111.394 Z"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(54.000000, 98.710000)">
            <path
              d="M7.0918,0.9965 L17.0498,0.9965 C17.0498,0.9965 18.0018,4.0545 14.8158,4.0545 C11.6298,4.0545 10.1468,5.9775 5.7638,5.9775 C1.3808,5.9775 0.6938,0.9965 0.6938,0.9965 L3.6388,0.9965"
              fill="#AA81F7"
            />
            <path
              d="M7.0918,0.9965 L17.0498,0.9965 C17.0498,0.9965 18.0018,4.0545 14.8158,4.0545 C11.6298,4.0545 10.1468,5.9775 5.7638,5.9775 C1.3808,5.9775 0.6938,0.9965 0.6938,0.9965 L3.6388,0.9965"
              stroke="#391572"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M76.7915,134.8119 C76.7915,136.3819 75.5195,137.6549 73.9495,137.6549 C72.3795,137.6549 71.1075,136.3819 71.1075,134.8119 C71.1075,133.2429 72.3795,131.9699 73.9495,131.9699 C75.5195,131.9699 76.7915,133.2429 76.7915,134.8119"
            fill="#FFFFFF"
          />
          <path
            d="M76.7915,134.8119 C76.7915,136.3819 75.5195,137.6549 73.9495,137.6549 C72.3795,137.6549 71.1075,136.3819 71.1075,134.8119 C71.1075,133.2429 72.3795,131.9699 73.9495,131.9699 C75.5195,131.9699 76.7915,133.2429 76.7915,134.8119 Z"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.1807,134.8119 C49.1807,135.8809 48.3147,136.7479 47.2457,136.7479 C46.1777,136.7479 45.3117,135.8809 45.3117,134.8119 C45.3117,133.7439 46.1777,132.8769 47.2457,132.8769 C48.3147,132.8769 49.1807,133.7439 49.1807,134.8119"
            fill="#FFFFFF"
          />
          <path
            d="M49.1807,134.8119 C49.1807,135.8809 48.3147,136.7479 47.2457,136.7479 C46.1777,136.7479 45.3117,135.8809 45.3117,134.8119 C45.3117,133.7439 46.1777,132.8769 47.2457,132.8769 C48.3147,132.8769 49.1807,133.7439 49.1807,134.8119 Z"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M113.0303,134.8119 C113.0303,135.8809 112.1643,136.7479 111.0953,136.7479 C110.0273,136.7479 109.1603,135.8809 109.1603,134.8119 C109.1603,133.7439 110.0273,132.8769 111.0953,132.8769 C112.1643,132.8769 113.0303,133.7439 113.0303,134.8119"
            fill="#FFFFFF"
          />
          <path
            d="M113.0303,134.8119 C113.0303,135.8809 112.1643,136.7479 111.0953,136.7479 C110.0273,136.7479 109.1603,135.8809 109.1603,134.8119 C109.1603,133.7439 110.0273,132.8769 111.0953,132.8769 C112.1643,132.8769 113.0303,133.7439 113.0303,134.8119 Z"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.564,135.1283 C89.564,123.2373 99.204,113.5973 111.096,113.5973 C113.325,113.5973 115.476,113.9363 117.499,114.5663"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.1313,130.893 C28.0983,121.03 36.8043,113.597 47.2463,113.597 C59.1373,113.597 68.7773,123.238 68.7773,135.128"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(90.000000, 98.710000)">
            <path
              d="M8.2046,0.9965 L16.1216,0.9965 C16.6636,0.9965 17.1076,1.5575 17.1076,2.2415 L17.1076,2.7955 C17.1076,3.4795 16.6636,4.0405 16.1216,4.0405 L1.5706,4.0405 C1.0276,4.0405 0.5836,3.4795 0.5836,2.7955 L0.5836,2.2415 C0.5836,1.5575 1.0276,0.9965 1.5706,0.9965 L4.2416,0.9965"
              fill="#AA81F7"
            />
            <path
              d="M8.2046,0.9965 L16.1216,0.9965 C16.6636,0.9965 17.1076,1.5575 17.1076,2.2415 L17.1076,2.7955 C17.1076,3.4795 16.6636,4.0405 16.1216,4.0405 L1.5706,4.0405 C1.0276,4.0405 0.5836,3.4795 0.5836,2.7955 L0.5836,2.2415 C0.5836,1.5575 1.0276,0.9965 1.5706,0.9965 L4.2416,0.9965"
              stroke="#391572"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M74.0635,135.1283 L76.7915,141.3573"
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.8696,141.7358 L78.8826,141.7358"
            stroke="#D6D6D6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M144.9229,124.3627 L134.9939,124.3627 C134.5909,124.3627 134.2619,124.0337 134.2619,123.6327 L134.2619,122.6607 C134.2619,122.2587 134.5909,121.9297 134.9939,121.9297 L144.9229,121.9297 C145.3249,121.9297 145.6539,122.2587 145.6539,122.6607 L145.6539,123.6327 C145.6539,124.0337 145.3249,124.3627 144.9229,124.3627"
            fill="#FFFFFF"
          />
          <path
            d="M144.9229,124.3627 L134.9939,124.3627 C134.5909,124.3627 134.2619,124.0337 134.2619,123.6327 L134.2619,122.6607 C134.2619,122.2587 134.5909,121.9297 134.9939,121.9297 L144.9229,121.9297 C145.3249,121.9297 145.6539,122.2587 145.6539,122.6607 L145.6539,123.6327 C145.6539,124.0337 145.3249,124.3627 144.9229,124.3627 Z"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M139.958,124.3627 L139.958,127.3997"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M98.2168,153.8598 L123.6288,153.8598"
            stroke="#391572"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(137.000000, 127.710000)">
            <polyline
              fill="#FFFFFF"
              points="0.8623 3.3539 0.8623 0.0069 5.0543 0.0069 5.0543 26.1139 0.8623 26.1139 0.8623 5.7509"
            />
            <polyline
              stroke="#83291B"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="0.8623 3.3539 0.8623 0.0069 5.0543 0.0069 5.0543 26.1139 0.8623 26.1139 0.8623 5.7509"
            />
          </g>
          <g transform="translate(134.000000, 153.710000)">
            <path d="M11.3579,0.2426 L0.5599,0.2426" fill="#FFFFFF" />
            <path
              d="M11.3579,0.2426 L0.5599,0.2426"
              stroke="#83291B"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M137.521,149.0053 C136.424,148.7983 135.24,149.1133 134.39,149.8373 C133.196,150.8563 132.575,152.6483 131.061,153.0583 C129.632,153.4433 128.269,152.3703 127.106,151.4543 C125.958,150.5493 124.74,149.7303 123.468,149.0083 C122.229,148.3043 120.874,147.6783 119.45,147.7263 C118.383,147.7633 117.499,148.1683 117.189,149.3173"
            stroke="#83291B"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.1895,149.3178 L117.1895,150.9038"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M116.5103,149.3178 L118.0963,149.3178"
            stroke="#ED0722"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M106.2168,59.5346 L114.2468,59.5346"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M111.9844,56.8119 L103.9544,56.8119 C103.9544,56.8119 102.2904,56.6459 102.2904,55.5119 C102.2904,54.3789 103.0154,54.2129 103.0154,54.2129"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M40.4346,87.9887 L48.4646,87.9887"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M46.2021,85.266 L38.1721,85.266 C38.1721,85.266 36.5081,85.1 36.5081,83.966 C36.5081,82.832 37.2331,82.667 37.2331,82.667"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M178.4932,68.2768 C174.3462,51.2978 163.9652,39.4158 153.5352,40.7758 C145.8622,41.7768 140.0552,49.7008 137.6572,60.7738 C130.9842,64.5798 126.9162,72.1468 127.9722,80.2358 C128.7432,86.1478 132.0932,91.0858 136.7362,94.0878 C138.8232,108.5658 152.1522,118.7288 166.7032,116.8318 C181.3762,114.9178 191.7192,101.4708 189.8052,86.7988 C188.7872,78.9938 184.4872,72.4378 178.4932,68.2768"
            fill="#FFFFFF"
          />
          <path
            d="M155.0791,69.0951 C167.5711,89.9001 165.0791,151.8241 165.0791,151.8241"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M150.3545,76.391 C155.0555,76.391 159.8715,82.447 159.8715,82.447"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M163.3857,100.268 C163.3857,100.268 170.2087,93.931 171.0597,87.595"
            stroke="#E2E8EE"
            strokeLinecap="round"
          />
          <path
            d="M165.7837,45.1078 C161.9837,41.8488 157.7637,40.2238 153.5347,40.7758 C145.8627,41.7768 140.0547,49.7008 137.6567,60.7738 C130.9847,64.5798 126.9167,72.1468 127.9717,80.2358 C128.7427,86.1478 132.0927,91.0858 136.7367,94.0868 C137.4907,99.3188 139.7117,103.9868 142.9297,107.7258"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M169.4287,48.891 C168.2707,47.462 167.0507,46.194 165.7837,45.108"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M149.668,113.3608 C154.624,116.2818 160.555,117.6328 166.704,116.8318 C181.376,114.9178 191.719,101.4708 189.805,86.7988 C188.787,78.9938 184.487,72.4378 178.493,68.2768"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
